import PropTypes from 'prop-types';
import { useState } from 'react';
import { Tooltip, Button, Divider, Collapse } from 'antd';
import { CodeOutlined, CopyOutlined } from '@ant-design/icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import reactElementToJSXString from 'react-element-to-jsx-string';

// project import
import SyntaxHighlight from '@/utils/SyntaxHighlight';
import { defaultColors } from '@/themes/antd-theme';

// ==============================|| CLIPBOARD & HIGHLIGHTER   ||============================== //

const Highlighter = ({ children }) => {
  const [highlight, setHighlight] = useState(false);

  return (
    <div className="relative">
      <div className={`flex justify-end p-2 ${highlight ? 'mb-2' : 'mb-0'}`}>
        <div className="flex gap-2 items-center">
          <CopyToClipboard text={reactElementToJSXString(children, { showFunctions: true, maxInlineAttributesLineLength: 100 })}>
            <Tooltip title="Copy the source" placement="topRight">
              <Button
                type="text"
                size="small"
                icon={<CopyOutlined />}
                style={{ fontSize: '0.875rem', color: defaultColors.text.secondary }}
              />
            </Tooltip>
          </CopyToClipboard>
          <Divider type="vertical" className="h-6" />
          <Tooltip title="Show the source" placement="topRight">
            <Button
              type="text"
              size="small"
              icon={<CodeOutlined />}
              style={{
                fontSize: '0.875rem',
                color: highlight ? defaultColors.primary : defaultColors.text.secondary
              }}
              onClick={() => setHighlight(!highlight)}
            />
          </Tooltip>
        </div>
      </div>
      <Collapse activeKey={highlight ? ['1'] : []} ghost>
        <Collapse.Panel key="1" showArrow={false} collapsible="disabled">
          {highlight && (
            <SyntaxHighlight>
              {reactElementToJSXString(children, {
                showFunctions: true,
                showDefaultProps: false,
                maxInlineAttributesLineLength: 100
              })}
            </SyntaxHighlight>
          )}
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

Highlighter.propTypes = {
  children: PropTypes.node
};

export default Highlighter;
